export default {
    path: '/inspection',
    name: 'Inspection',
    component: () => import(/* webpackChunkName: "inspection" */ '../../views/inspection/inspection.vue')
}